import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TableModule } from 'primeng/table'
import { TableUnsortDirective } from './table-unsort.directive'

@NgModule({
  declarations: [TableUnsortDirective],
  imports: [CommonModule, TableModule],
  exports: [TableUnsortDirective],
})
export class TableUnsortModule {}
